import React from "react";
import Lock from "./Lock";
import Pencil from "./Pencil";

export default function MasterPromptList({
  orderedGuardrails,
  selectedGuardrail,
  setSelectedGuardrail,
}) {
  return (
    <div className="master-prompt-list">
      <div className="prompt-list-header">
        <h5>Prompt Parts</h5>
      </div>
      <div className="prompt-list-body">
        {orderedGuardrails?.map((guardrail, index) => (
          <button
            className={`prompt-button ${
              selectedGuardrail?.id === guardrail?.id
                ? "prompt-button-selected"
                : ""
            }`}
            onClick={() => setSelectedGuardrail(guardrail)}
            key={guardrail?.id}
          >
            {guardrail?.promptTitle}
            {guardrail?.promptTitle === "Disallowed Topics" ? (
              <Pencil className="prompt-icon" />
            ) : (
              <Lock className="prompt-icon" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
